import { Component, inject, OnDestroy } from '@angular/core';
import { IonApp, IonContent, IonRouterOutlet, ModalController } from "@ionic/angular/standalone";
import {
  addCircleOutline,
  albumsOutline,
  alertCircleOutline,
  arrowBack,
  cameraOutline,
  carOutline,
  checkmark,
  checkmarkCircleOutline,
  checkmarkDoneCircleOutline,
  chevronDown,
  clipboardOutline,
  close,
  closeCircleOutline,
  closeOutline,
  cloudDoneOutline,
  cloudOfflineOutline,
  cloudUploadOutline,
  documentAttachOutline,
  documentOutline,
  documentTextOutline, eyeOffOutline,
  eyeOutline,
  briefcaseOutline,
  hourglassOutline,
  informationCircleOutline,
  locationOutline, lockOpenOutline,
  logInOutline,
  logOutOutline,
  mapOutline,
  medalOutline,
  moonOutline,
  pauseCircle,
  pencil,
  peopleOutline,
  personAddOutline,
  personOutline,
  playCircle,
  refreshOutline,
  saveOutline,
  stopCircle,
  sunnyOutline,
  time,
  timeOutline,
  train,
  trainOutline,
  trainSharp,
  trashOutline,
  warningOutline
} from 'ionicons/icons';
import { addIcons } from "ionicons";
import { AuthenticationService } from "@core/services/authentication.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { NetworkService } from "@core/services/network.service";
import { ActuatorService } from "@core/api/actuator/services/actuator.service";
import { HeaderComponent } from "@core/components/header/header.component";
import { MenuComponent } from "@core/components/menu/menu.component";
import { LogPanelComponent } from "@core/components/log-panel/log-panel.component";

@Component({
  selector: 'pkp-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonApp, IonRouterOutlet, HeaderComponent, MenuComponent, IonContent, LogPanelComponent],
  providers: [ModalController]
})
export class AppComponent implements OnDestroy {

  status: null | string = null;

  #authService = inject(AuthenticationService);
  #translate = inject(TranslateService);
  #router = inject(Router);
  #networkService = inject(NetworkService);
  #apiService = inject(ActuatorService);

  constructor() {
    this.configTranslate();
    this.setDarkMode();

    this.addIcons();

    if (!this.#authService.isLoggedIn) {
      this.#router.navigate(['login']);
    }

    this.healthCheck();
    this.#networkService.init();
  }

  configTranslate() {
    this.#translate.addLangs(['hu']);
    this.#translate.setDefaultLang('hu');
    this.#translate.use('hu');
  }

  addIcons() {
    addIcons({
      addCircleOutline, // name="add-circle-outline"
      albumsOutline,
      alertCircleOutline,
      arrowBack,
      cameraOutline,
      carOutline,
      checkmark,
      checkmarkCircleOutline,
      checkmarkDoneCircleOutline,
      chevronDown,
      clipboardOutline,
      close,
      closeCircleOutline,
      closeOutline,
      cloudDoneOutline,
      cloudOfflineOutline,
      cloudUploadOutline,
      documentAttachOutline,
      documentOutline,
      documentTextOutline,
      eyeOutline,
      eyeOffOutline,
      briefcaseOutline,
      hourglassOutline,
      informationCircleOutline,
      locationOutline,
      lockOpenOutline,
      logInOutline,
      logOutOutline,
      mapOutline,
      medalOutline,
      moonOutline,
      pauseCircle,
      pencil,
      peopleOutline,
      personAddOutline,
      personOutline,
      playCircle,
      refreshOutline,
      saveOutline,
      stopCircle,
      sunnyOutline,
      time,
      timeOutline,
      train,
      trainOutline,
      trainSharp,
      trashOutline,
      warningOutline
    });
  }

  healthCheck() {
    this.#apiService.healthCheck().subscribe((res) => {
      this.status = res.status;
      setTimeout(() => this.status = null, 10000);
    }, error => {
      console.error('Health check error:', error);
      this.status = 'error';
      setTimeout(() => this.status = null, 10000);
    });
  }

  setDarkMode() {
    const isDarkMode = localStorage.getItem('PKPDarkMode') === 'true'
    document.documentElement.classList.toggle('ion-palette-dark', isDarkMode);
  }

  ngOnDestroy() {
    this.#networkService.destroy();
  }
}
